import * as React from 'react';

import { cn } from '@/components/atoms/primitives/utils';

/**
 * WEB-1001 — the design-system badge (DS 1.9.0 `.a-badge`): a 24 high glass
 * pill in caption / 500. `accent` washes it teal, `cta` amber (a label that
 * belongs to the view's CTA), `solid` fills it with the accent.
 */
export type BadgeVariant = 'accent' | 'cta' | 'solid';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

export function Badge({ variant, className, ...props }: BadgeProps): React.ReactElement {
  return <span className={cn('a-badge', variant && `a-badge--${variant}`, className)} {...props} />;
}
